import { makeTanstackQuery } from '@provider/tanstack';
import { useUserIdentityState } from '@provider/user-identity';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { getClassesRequest } from './request.get-classes.js';

const getClassesQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 8 * HOURS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: (input) => {
    var _a;
    return [
      "userdata/get-classes",
      (_a = input.user) == null ? void 0 : _a.id
    ];
  },
  queryFn: (input) => getClassesRequest(input.user),
  useQueryInput(queryFactory) {
    const user = useUserIdentityState((state) => state.user);
    return queryFactory({ user });
  }
});

export { getClassesQuery };
//# sourceMappingURL=query.get-classes.js.map
